import { MockScenario } from '@/util/xhr-mock';

import defaults from './default';

export default {
  dependencies: [defaults],
  name: 'project/highrise',
  mocks: [],
} as MockScenario;
